import { makeStyles } from '@material-ui/core/styles';
const drawerWidth = 300;

export const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
		backgroundColor: theme.palette.background.paper
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
	},
	drawerContainer: {
		padding: '30px 0px 0px 0px',
		overflow: 'auto',
	},
	content: {
		flexGrow: 1,
		// padding: theme.spacing(3),
	},
    listItem:{
        // "&:hover":{
		// 	color:'white',           
        //     backgroundColor: "black",
        // }
    },
	itemMenu: {
        // color: 'black',
        fontFamily: 'roboto',
        margin: 0,
		"&>.MuiTypography-body1":{
			'@media (max-width:2000px)':{ // web
				fontSize: '0.9rem',
			 },
			'@media (max-width:1000px)':{ // web
				fontSize: '0.9rem',
			 },
			'@media (max-width:768px)':{ //ipad
				fontSize: '0.9rem',
			 },
			'@media (max-width:415px)':{ //mobile
				fontSize: '0.9rem',
				 marginRight: '10%',
			 }		
        },
	}
}));